import apiClient from '@/lib/api-client'
import type { SocialLink } from '@/types'

export interface CreateSocialLinkDTO {
  platform: string
  url: string
  label?: string
  sort_order?: number
}

export interface UpdateSocialLinkDTO {
  platform?: string
  url?: string
  label?: string
  is_active?: boolean
  sort_order?: number
}

export const socialLinksApi = {
  async list(): Promise<SocialLink[]> {
    const response = await apiClient.get<{ success: boolean; data: SocialLink[] }>('/social-links')
    return response.data.data
  },

  async create(data: CreateSocialLinkDTO): Promise<SocialLink> {
    const response = await apiClient.post<{ success: boolean; data: SocialLink }>(
      '/social-links',
      data,
    )
    return response.data.data
  },

  async update(id: string, data: UpdateSocialLinkDTO): Promise<SocialLink> {
    const response = await apiClient.put<{ success: boolean; data: SocialLink }>(
      `/social-links/${id}`,
      data,
    )
    return response.data.data
  },

  async remove(id: string): Promise<void> {
    await apiClient.delete(`/social-links/${id}`)
  },

  async reorder(order: string[]): Promise<void> {
    await apiClient.put('/social-links/reorder', { order })
  },
}
